import React, { useEffect, useState } from "react";
import { Trophy, Heart } from "lucide-react";
import api from "../lib/api";

const Leaderboard = ({ limit = 5, compact = false }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/leaderboard/public", { params: { limit } })
            .then((r) => setItems(r.data))
            .catch(() => {});
    }, [limit]);

    if (items.length === 0) return null;

    return (
        <section className={compact ? "" : "max-w-3xl mx-auto px-6 sm:px-8 py-12"} data-testid="leaderboard-section">
            {!compact && (
                <div className="text-center mb-8">
                    <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#E53935] mb-3 flex items-center justify-center gap-2">
                        <Trophy className="w-3.5 h-3.5" strokeWidth={2} />
                        Top supporters
                    </p>
                    <h2 className="font-heading text-2xl sm:text-3xl text-[#1C252E] font-medium tracking-tight">
                        Cheering on our biggest champions
                    </h2>
                </div>
            )}
            <ol className="space-y-2" data-testid="leaderboard-list">
                {items.map((d, i) => (
                    <li
                        key={i}
                        data-testid={`leader-${i}`}
                        className="bg-white border border-black/5 rounded-2xl px-5 py-4 flex items-center gap-4 hover:border-[#E53935]/40 transition-all"
                    >
                        <div className={`w-9 h-9 rounded-full flex items-center justify-center font-heading text-sm font-bold flex-shrink-0 ${
                            i === 0 ? "bg-[#E53935] text-white" :
                            i === 1 ? "bg-[#1C252E] text-white" :
                            i === 2 ? "bg-[#F2D8D5] text-[#E53935]" :
                            "bg-[#F4F1EA] text-[#4A5568]"
                        }`}>
                            {i + 1}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="font-heading text-base text-[#1C252E] font-medium truncate">
                                {d.display_name}
                                {d.is_anonymous_bucket && (
                                    <span className="text-xs text-[#4A5568] font-normal ml-2">· combined</span>
                                )}
                            </p>
                            <p className="text-xs text-[#4A5568]">
                                {d.gift_count} {d.gift_count === 1 ? "gift" : "gifts"}
                            </p>
                        </div>
                        <p className="font-heading text-xl text-[#E53935] font-medium whitespace-nowrap">
                            ${Math.round(d.total).toLocaleString()}
                        </p>
                    </li>
                ))}
            </ol>
            {!compact && (
                <p className="text-xs text-[#4A5568] text-center mt-6 flex items-center justify-center gap-1.5">
                    <Heart className="w-3.5 h-3.5 text-[#E53935]" fill="#E53935" strokeWidth={1.5} />
                    Every gift counts — names shown with first-letter privacy
                </p>
            )}
        </section>
    );
};

export default Leaderboard;
